export const MaxIssueLinksStatsCount = {
	JSW: 999,
	JWM: 9,
};
